import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9842b782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.radiolist || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", null, [
              (_ctx.IsStib === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "实际控制人：" + _toDisplayString(_ctx.Controller || '无'), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_a_radio_group, {
                value: _ctx.radiovalue,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radiovalue) = $event)),
                "button-style": "solid",
                onChange: _ctx.changeradio
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radiolist, (item, i) => {
                    return (_openBlock(), _createBlock(_component_a_radio_button, {
                      value: item,
                      key: 'sdgd' + i
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _createVNode(_component_Table, {
              data: _ctx.data,
              columns: _ctx.columns,
              bordered: true,
              onShowdrawer: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showdrawer(1, 10, $event))),
              pagination: false
            }, null, 8, ["data", "columns"]),
            _createVNode(_component_Drawer, {
              title: 'sdgddrawer',
              currentshareholder: _ctx.currentshareholder,
              class: "light sdgdwrap",
              width: 560,
              visible: _ctx.visible,
              mask: true,
              onClose: _ctx.onClose,
              getContainer: _ctx.getContainer,
              wrapClassName: 'sdgd',
              tableData: _ctx.data2,
              columns: _ctx.columns2,
              option: _ctx.optiongd_detail,
              total2: _ctx.total2,
              onChangesize: _ctx.changesize
            }, null, 8, ["currentshareholder", "visible", "onClose", "getContainer", "tableData", "columns", "option", "total2", "onChangesize"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}